import { PrivilegeType } from "../../Enums/ChoiceEnums";
import { getObject } from "../ChoiceApi";

// Get the screens and security info
export async function  getScreens(): Promise<IUserConfigurationScreens[]|undefined> {
    return await getObject<IUserConfigurationScreens[]>("api/UserConfiguration/Screens");
}

export interface IUserConfigurationScreens {
    screenId: string;
    screenName: string;
    height: number;
    width: number;
    security: PrivilegeType;
}
